let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("39h9p")).then(() => parcelRequire('3i2SZ'));